import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoodreadsComponent } from './simple-icons-goodreads.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoodreadsComponent ],
    exports:      [ SimpleIconsGoodreadsComponent ],
    bootstrap:    []
})
export class SimpleIconsGoodreadsModule {}
